<footer class="footer-container" #footerRef [class.footer-animate]="isVisible">
    <img class="ellipse ellipse-left" src="assets/img/icons/common/footer-ellipse1.svg" />
    <img class="ellipse ellipse-right" src="assets/img/icons/common/footer-ellipse2.svg" />
    <div class="footer-inner">
        <div class="footer-col footer-col-brand">
            <a class="footer-brand" [routerLink]="['/home']">
                <img class="brand-logo-only" src="assets/img/brand/white.png" />
                <img class="brand-logo-tagline" src="assets/img/brand/white-w-tagline.svg" />
            </a>
            <p class="footer-tagline">"The secure way to pay."</p>
        </div>

        <div class="footer-row-tablet">
            <div class="footer-col footer-col-nav">
                <a class="footer-link" [routerLink]="['/home']" routerLinkActive="footer-link-active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
                <a class="footer-link" [routerLink]="['/features/services']" routerLinkActive="footer-link-active">Services</a>
                <a class="footer-link" [routerLink]="['/features/about']" routerLinkActive="footer-link-active">About Us</a>
                <!-- Tempo remove for production deployment (uncomment when our partners page is ready to be deployed) -->
                <!-- <a class="footer-link" *ngIf="!isLoggedIn" [routerLink]="['/features/our-partners']" routerLinkActive="footer-link-active">Our Partners</a> -->
                <a class="footer-link" [routerLink]="['/features/user-guide']" routerLinkActive="footer-link-active">User Guide</a>
            </div>

            <div class="footer-col footer-col-social">
                <p>Connect with us:</p>
                <div class="social-icons">
                    <a href="https://www.facebook.com/Securipay/" target="_blank"><img src="assets/img/icons/common/Facebook.svg" /></a>
                    <a href="https://instagram.com" target="_blank"><img src="assets/img/icons/common/Instagram.svg" /></a>
                    <a href="https://linkedin.com" target="_blank"><img src="assets/img/icons/common/LinkedIn.svg" /></a>
                </div>
                <div class="footer-copyright-row">
                    <p class="copyright">
                    <a href="https://www.bestinc.com.ph" target="_blank">&copy; {{ test | date: "yyyy" }} Backend Solutions <span>& Technologies Inc.</span></a>
                    </p>
                </div>
            </div>

            <div class="footer-col footer-col-contact">
                <p><strong>Address:</strong> 5th floor, Phinma Plaza, 39 Plaza Drive, Rockwell Center Makati City</p>
                <p><strong>Email:</strong> sales&#64;bestinc.com.ph</p>
                <p><strong>Contact No:</strong> 09922654586 / 09176885995</p>
            </div>
        </div>

        <div class="footer-copyright-row">
            <p class="copyright">
                <a href="https://www.bestinc.com.ph" target="_blank">&copy; {{ test | date: "yyyy" }} Backend Solutions <span>& Technologies Inc.</span></a>
            </p>
        </div>
    </div>
</footer>